import { HOME_PATH, NEW_PATH, PROFESSIONS_PATH, SCHOOLS_PATH } from "../../../../constants/RoutesConstants";
import React, { useState } from "react";

import Fab from "../../ui/Fab";
import Icon from "../../ui/Icon/styled";
import Styled from "./styled";
import getIdSelector from "../../../../state/selectors/ClientSelectors/getIdSelector";
import refactorProps from "../../../../helpers/refactorProps";
import useHistoryPushPreventUnlogged from "../../../../hooks/useHistoryPushPreventUnlogged";
import { useRouteMatch } from "react-router";
import { useSelector } from "react-redux";

const FabGroup: React.FC = () => {
    const [active, toggleActive] = useState(false);
    const isUserLoggedIn = useSelector((state: Store) => getIdSelector(state));
    const pushToNewSchool = useHistoryPushPreventUnlogged(`${SCHOOLS_PATH}${NEW_PATH}`);
    const pushToNewProfession = useHistoryPushPreventUnlogged(`${PROFESSIONS_PATH}${NEW_PATH}`);
    const match = useRouteMatch({
        path: HOME_PATH,
        exact: true
    });
    if (!isUserLoggedIn) {
        return null;
    }
    return (
        <>
            <Fab primary={!Boolean(match)} active={active} onClick={() => toggleActive(!active)}>
                +
            </Fab>
            <Styled {...refactorProps({ active })}>
                {/*<Fab mini active={active}>
                    <Icon name="employee" />
                </Fab>*/}
                <Fab mini primary={!Boolean(match)} active={active} onClick={() => pushToNewSchool()}>
                    <Icon name="university" />
                </Fab>
                <Fab mini primary={!Boolean(match)} active={active} onClick={() => pushToNewProfession()}>
                    <Icon name="briefcase" />
                </Fab>
            </Styled>
        </>
    );
};

export default FabGroup;
